import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Drops the BFF cookie, then reloads onto "/". A reload rather than invalidating the session
 * query: the next persoon to sign in on this tab must not inherit the previous one's cached
 * korpsen or the korps left selected in a form.
 */
export function useSignOut() {
  return useMutation({
    mutationFn: async () => {
      const { response } = await api.POST("/api/sign-out");
      if (!response.ok) throw new Error(`Uitloggen is mislukt (${response.status}).`);

      window.location.assign("/");
    },
  });
}
